import { Component, OnInit } from '@angular/core';
import { Routes,Router,RouterModule}  from '@angular/router';

import { AppComponent } from '../../app.component';

import { TopnavComponent } from '../../topnav/topnav.component';
import { SidemenuComponent } from '../../sidemenu/sidemenu.component';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../../appSettings';
import { LoginService } from '../../services/login.service';
import { CommonService } from '../../services/common.service';
declare var jquery:any;
declare var $ :any;
import { Injectable } from '@angular/core';
@Component({
  selector: 'app-managepayments',
  templateUrl: './managepayments.component.html',
  styleUrls: ['./managepayments.component.css']
})
export class ManagepaymentsComponent implements OnInit {
  getpackagelistRestApiUrl:string = AppSettings.getallpaymentdet;  
  currentUser:any;
  currentUserID:any;
  currentUsername:any;
  currentUsergroup:any;
  currentUserStatus:any;
  currentAllUsers:any;
  model: any = {};
  alldata: any = {};
  paymentdetails:Array<Object>;
  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router,private http:Http) { 
      document.body.className="theme-red";

  }


  ngOnInit() {
    this.loginService.localStorageData();
      this.loginService.viewsActivate();
        this.model.usergroup=localStorage.getItem('currentUsergroup');
    if(this.model.usergroup==2)
    {
      this.loginService.logout();
    }
      this.CommonService.getdata(this.getpackagelistRestApiUrl)
        .subscribe(packagedet =>{
            if(packagedet.result!="")
            { 
              this.paymentdetails= packagedet.result;
            } 
             
        });
  }

  logout(){
    this.loginService.logout();
  }

}
